import React from 'react';
import TimeInput from '../TimeInput';
import { create } from 'react-test-renderer';
import { render, screen, fireEvent } from '@testing-library/react';
import moment from 'moment/moment';
import userEvent from '@testing-library/user-event';

describe('TimeInput Component', () => {
  const onChange = () => { };
  it('should be defined', () => {
    const { container } = render(<TimeInput onChange={onChange} />);
    expect(container).toBeDefined();
  });

  it('popup opens', async () => {
    const user = userEvent.setup();
    render(<TimeInput onChange={onChange}/>);
    const input = screen.getByRole('textbox');
    expect(input).toBeInTheDocument();
    await user.click(input);
    expect(screen.queryByLabelText('core-timepicker')).toBeInTheDocument();
  });

  it('it calls onFocus', async () => {
    const user = userEvent.setup();
    const spy = jest.spyOn(TimeInput.prototype, 'onFocus');
    render(<TimeInput onChange={onChange}/>);
    const input = screen.getByRole('textbox');
    await user.click(input);
    expect(spy).toHaveBeenCalledTimes(1);
  });

  it('is disabled', () => {
    render(<TimeInput disabled onChange={onChange}/>);
    const input = screen.getByRole('textbox');
    expect(input).toBeDisabled();
  });

  it('is readOnly', () => {
    render(<TimeInput readOnly onChange={onChange}/>);
    const input = screen.getByRole('textbox');
    expect(input).toHaveAttribute('readonly');
  });

  it('should update time on prop selected update', () => {
    const time = moment.utc(new Date());
    const timeFormat = 'HH:mm';
    const { rerender } = render(<TimeInput timeFormat={timeFormat} selected={time} onChange={onChange}/>);
    const input = screen.getByRole('textbox');
    expect(input).toHaveValue(TimeInput.formatDate({ timeFormat }, time));

    const updatedTime = moment.utc(new Date());
    rerender(<TimeInput selected={updatedTime} timeFormat={timeFormat} onChange={onChange}/>);
    expect(input).toHaveValue(TimeInput.formatDate({ timeFormat }, updatedTime));
  });

  it('should update time on prop update', () => {
    const time = moment.utc(new Date());
    const props = TimeInput.defaultProps;
    const { rerender } = render(<TimeInput selected={time} onChange={onChange}/>);
    const input = screen.getByRole('textbox');
    expect(input).toHaveValue(TimeInput.formatDate(props, time));

    const timeFormat = 'HH:mm';
    rerender(<TimeInput selected={time} timeFormat={timeFormat} onChange={onChange}/>);
    expect(screen.getByRole('textbox')).toHaveValue(TimeInput.formatDate({ timeFormat }, time));
  });

  it('should call on change on clear event', async () => {
    const time = moment.utc(new Date());
    const props = TimeInput.defaultProps;
    props.selected = time;
    const onChange = jest.fn();
    render(<TimeInput props isClearable={true} onChange={onChange} />);
    const input = screen.getByRole('textbox');

    fireEvent.change(input, { target: { value: '' } });
    expect(onChange).toBeCalled();
  });

  describe('snapshots', () => {
    it('should match snapshot', () => {
      const component = create(<TimeInput selected={moment.utc('00:00', true)} onChange={onChange}/>).toJSON();
      expect(component).toMatchSnapshot();
    });

    it('should match clearable snapshot', () => {
      const component = create(<TimeInput isClearable={true} selected={moment.utc('00:00', true)} onChange={onChange}/>).toJSON();
      expect(component).toMatchSnapshot();
    });

    it('should match with custom locale snapshot', () => {
      const component = create(<TimeInput locale={'es'} selected={moment.utc('00:00', true)} onChange={onChange}/>).toJSON();
      expect(component).toMatchSnapshot();
    });
  });
});
